import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

import { ThreeDotsIcon } from '../../assets/icons/index';

export const Breadcrumb = ({ className, ...props }: React.ComponentProps<'nav'>) => (
  <nav
    aria-label="breadcrumb"
    className={twMerge('w-full', className)}
    data-slot="breadcrumb"
    {...props}
  />
);

export const BreadcrumbList = ({ className, ...props }: React.ComponentProps<'ol'>) => (
  <ol
    className={twMerge(
      'flex flex-wrap items-center gap-2 break-words text-xs font-[450] leading-4',
      className,
    )}
    data-slot="breadcrumb-list"
    {...props}
  />
);

export const BreadcrumbItem = ({ className, ...props }: React.ComponentProps<'li'>) => (
  <li
    className={twMerge('inline-flex items-center gap-2', className)}
    data-slot="breadcrumb-item"
    {...props}
  />
);

export const BreadcrumbLink = ({
  asChild,
  className,
  ...props
}: { asChild?: boolean } & React.ComponentProps<'a'>) => {
  const Comp = asChild ? Slot : 'a';

  return (
    <Comp
      className={twMerge('text-brand-700 transition-colors hover:text-brand-800', className)}
      data-slot="breadcrumb-link"
      {...props}
    />
  );
};

export const BreadcrumbPage = ({ className, ...props }: React.ComponentProps<'span'>) => (
  <span
    aria-current="page"
    aria-disabled="true"
    className={twMerge('font-[450] text-gray-400', className)}
    data-slot="breadcrumb-page"
    role="link"
    {...props}
  />
);

export const BreadcrumbSeparator = ({
  children,
  className,
  ...props
}: React.ComponentProps<'li'>) => (
  <li
    aria-hidden="true"
    className={twMerge('text-gray-400 [&>svg]:size-3.5', className)}
    data-slot="breadcrumb-separator"
    role="presentation"
    {...props}
  >
    {children ?? '/'}
  </li>
);

export const BreadcrumbEllipsis = ({ className, ...props }: React.ComponentProps<'span'>) => (
  <span
    aria-hidden="true"
    className={twMerge('flex size-4 items-center justify-center', className)}
    data-slot="breadcrumb-ellipsis"
    role="presentation"
    {...props}
  >
    <ThreeDotsIcon height={4} iconColor="#344054" width={11} />
    <span className="sr-only">More</span>
  </span>
);
